import React from 'react';
import Icon from 'icon';
import { useFormInput, useErrors } from '@/hooks/useForm';
import { navigate } from 'gatsby';
import s from './search.module.scss';

export default function SearchBar(props) {
  const search = useFormInput('');
  const searchErrors = useErrors({ search: search.state });
  return (
    <div className={s.search}>
      <Icon className={s.icon} icon="search" />
      <input
        type="text"
        name={`search-${props.idx}`}
        id={`search-${props.idx}`}
        value={search.state.value}
        {...search.events}
        className={`${s.input} ${searchErrors.name && 'error'}`}
      />
    </div>
  );
}
